/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

const mobileBreakpoint = '768px';

export const TileRow = styled.div`
  display: flex;
  flex-direction: row;
  background: var(--cm-color-white-base);
  justify-content: center;
  margin-top: 1rem;
  gap: 1rem;
  flex-wrap: wrap;

  @media screen and (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const StyledTile = styled.div`
  min-width: 120px;
  height: 120px;
  color: var(--cm-color-black-primary-text);
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${mobileBreakpoint}) {
    min-width: 100%;
    width: 100%;
    flex: none;
  }
`;

export const TileValue = styled.div`
  font-size: 2.5rem;
  font-weight: 200;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const TileValueGreen = styled(TileValue)`
  color: var(--cds-support-success);
`;
